import lazyLoading from './lazyLoading'
import CommonLayout from '../components/Layouts/Common'
import NurseGuard from './guards/nurse-guard'

export default [
  {
    path: '/nurse',
    component: CommonLayout,
    beforeEnter: NurseGuard,
    children: [
      {
        name: 'nurse.dashboard',
        path: 'dashboard',
        component: lazyLoading('Dashboard/Index'),
        meta: {
          module: 'dashboard',
        },
      },
      {
        name: 'nurse.appointments',
        path: 'appointments',
        component: lazyLoading('Nurse/Appointments/Index'),
        meta: {
          module: 'appointments',
        },
      },
      {
        name: 'nurse.appointments.create',
        path: 'appointments/create',
        component: lazyLoading('Nurse/Appointments/Create'),
        meta: {
          module: 'createAppointments',
        },
      },
      {
        name: 'nurse.appointments.show',
        path: 'appointments/:id',
        component: lazyLoading('Appointments/Show'),
        meta: {
          module: 'appointments',
        },
      },
      {
        name: 'nurse.new_issue',
        path: 'issue_appointments/:id?',
        component: lazyLoading('Issues/Schedule/Form'),
        meta: {
          module: 'appointments',
        },
      },
      {
        name: 'nurse.exams',
        path: 'exams',
        component: lazyLoading('Nurse/Exams/Index'),
        meta: {
          module: 'exams',
        },
      },
      {
        name: 'nurse.exams.create',
        path: 'exams/create',
        component: lazyLoading('Exams/Create'),
        meta: {
          module: 'exams',
        },
      },
      {
        name: 'nurse.exams.show',
        path: 'exams/:id',
        component: lazyLoading('Exams/Show'),
        meta: {
          module: 'exams',
        },
      },
      {
        name: 'nurse.profile',
        path: 'profile',
        component: lazyLoading('Profile'),
        meta: {
          module: 'dashboard',
        },
      },
      {
        name: 'nurse.conversations',
        path: 'conversations',
        component: lazyLoading('Conversations/Index'),
        meta: {
          module: 'chat',
        },
      },
    ],
  },
]
